export const decodeB64 = (str: string): string => atob(str);

export const encodeB64 = (str: string): string => btoa(str);
